/* Defy The Norm / offer pages (digital products).
   1. Buy now: adds the product (unless it is already in the cart) and goes straight to checkout.
      Without JavaScript the same form posts to /cart/add and Shopify forwards to checkout.
   2. Sticky buy bar: shows once the hero buy box has scrolled away, hides over the other
      buy buttons and the footer so there is never two of them on screen. */

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

async function inCart(id) {
  try {
    const res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
    const cart = await res.json();
    return cart.items.some((i) => i.variant_id === id);
  } catch (e) {
    return false;
  }
}

function setBusy(form, busy) {
  const btn = form.querySelector('button');
  if (!btn) return;
  const span = btn.querySelector('span');
  if (busy) {
    btn.setAttribute('aria-busy', 'true');
    if (span) { span.dataset.text = span.textContent; span.textContent = 'Heading to checkout'; }
  } else {
    btn.removeAttribute('aria-busy');
    if (span && span.dataset.text) span.textContent = span.dataset.text;
  }
}

if (!window.__dtnOffer) {
  window.__dtnOffer = true;

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest && e.target.closest('[data-dtn-buy]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    setBusy(form, true);
    const id = Number(form.dataset.variant);
    try {
      if (!(await inCart(id))) {
        const res = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] })
        });
        if (!res.ok) throw new Error(String(res.status));
      }
      window.location.href = ROOT + 'checkout';
    } catch (err) {
      form.submit();
    }
  });

  // Coming back from checkout with the back button restores the page from cache: reset the buttons
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-dtn-buy]').forEach((f) => setBusy(f, false));
  });

  const bar = document.querySelector('[data-dtn-offer-bar]');
  const anchor = document.querySelector('.dtn-offer__buy');
  if (bar && anchor && 'IntersectionObserver' in window) {
    let past = false;
    const seen = new Set();
    const update = () => {
      const on = past && seen.size === 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.inert = !on;
      document.documentElement.classList.toggle('dtn-has-offer-bar', on);
    };
    new IntersectionObserver(([entry]) => {
      past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      update();
    }).observe(anchor);
    const others = document.querySelectorAll('.dtn-inside__card [data-dtn-buy], [data-dtn-final] [data-dtn-buy], footer, .footer-group');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => (en.isIntersecting ? seen.add(en.target) : seen.delete(en.target)));
      update();
    });
    others.forEach((el) => io.observe(el));
  }
}
